import { cn } from '@sistemas/ui'

import { useLiveStatus, type LiveStatus } from '@/lib/realtime'

const COPY: Record<LiveStatus, { label: string; hint: string; tone: string }> = {
  ao_vivo: { label: 'Ao vivo', hint: 'O que o time muda aparece aqui sem recarregar.', tone: 'bg-success' },
  conectando: { label: 'Conectando', hint: 'Ligando o tempo real…', tone: 'bg-warning animate-pulse' },
  caiu: {
    label: 'Sem tempo real',
    hint: 'A conexão ao vivo caiu. As telas seguem funcionando; recarregue para ver novidades.',
    tone: 'bg-destructive',
  },
  desligado: { label: 'Sem tempo real', hint: 'Tempo real desligado.', tone: 'bg-muted-foreground/50' },
}

/**
 * Um ponto no topo: verde quando o Hub está recebendo as mudanças do time
 * ao vivo. Sem ele, "não mudou nada" e "não estou vendo" ficam iguais.
 */
export function LiveIndicator() {
  const status = useLiveStatus()
  const copy = COPY[status]
  return (
    <span
      role="status"
      aria-label={`${copy.label}. ${copy.hint}`}
      title={copy.hint}
      className="hidden items-center gap-1.5 rounded px-1.5 text-[11px] text-muted-foreground md:inline-flex"
    >
      <span className={cn('h-2 w-2 rounded-full', copy.tone)} aria-hidden />
      {copy.label}
    </span>
  )
}
